import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {ClockTimeCircle} from 'components/Ui/Icon';
import {Activity, PreleadProjectReminderCreateActivity} from 'api';
import useProjectName from './useProjectName';
import UserName from './UserName';

interface PreleadContactCreate extends Activity {
  resource: PreleadProjectReminderCreateActivity;
}

interface Props {
  activity: PreleadContactCreate;
}

const PreleadProjectReminderCreateActivityComponent = ({activity}: Props) => {
  const {projectName} = useProjectName(activity);

  return (
    <>
      {projectName && <Project>{projectName}</Project>}
      <Summary>
        <BadgeWrapper>
          <ClockTimeCircle />
        </BadgeWrapper>
        <UserNameWrapper>
          <UserName activity={activity} />
        </UserNameWrapper>
        <StatusLabel color="#EB5757">リマインド</StatusLabel>
        <span>{moment(activity.createdAt).format('YYYY/MM/DD HH:mm')}</span>
      </Summary>
      <Remind>
        <span>
          {moment(activity.resource.preleadProjectReminder.remindAt).format(
            'MM/DD(ddd) HH:mm',
          )}
        </span>
        <span>{activity.resource.preleadProjectReminder.memo}</span>
      </Remind>
    </>
  );
};

const Summary = styled.div`
  margin-left: -15px;
  display: flex;
  align-items: center;
  width: 480px;
  height: 30px;
`;

const Project = styled.div`
  margin-left: 33px;
  font-size: 10px;
  color: var(--text-color-2);
`;

const BadgeWrapper = styled.div`
  z-index: 1;
  display: flex;
  width: 30px;
  height: 30px;
  margin-right: 20px;
  justify-content: center;
  align-items: center;
`;

const UserNameWrapper = styled.div`
  margin-right: 12px;
`;

const StatusLabel = styled.span<{color: string}>`
  margin-right: 12px;
  background-color: ${({color}) => color};
  ${({color}) => !color && 'border: 1px solid var(--text-color-3)'};
  color: ${({color}) => (color ? 'white' : 'var(--text-color-3)')};
  border-radius: 20px;
  padding: 4px 16px;
  font-size: 10px;
  height: 22px;
`;

const Remind = styled.span`
  padding: 0 34px;
  display: flex;
  flex-direction: column;

  > span {
    font-size: 12px;
    line-height: 17px;
    color: var(--text-color-1);
    white-space: break-spaces;
  }
`;

export default PreleadProjectReminderCreateActivityComponent;
